/** @format */

import { createAsyncThunk } from "@reduxjs/toolkit";
import {
	submitFetchUserInvitations,
	submitAcceptCircleInvitation,
	submitDenyCircleInvitation,
	submitSendCircleInvite,
} from "../services/circleInvitationService";

export const sendCircleInvite = createAsyncThunk(
	"circleInvitation/send",
	async (
		{
			circleId,
			inviterUserId,
			inviteeEmail,
			inviteeFirstName,
			inviteeLastName,
			inviteePhone,
		}: {
			circleId: string;
			inviterUserId: string;
			inviteeEmail: string;
			inviteeFirstName: string;
			inviteeLastName: string;
			inviteePhone?: string;
		},
		{ rejectWithValue },
	) => {
		try {
			const response = await submitSendCircleInvite({
				circleId,
				inviterUserId,
				inviteeEmail,
				inviteeFirstName,
				inviteeLastName,
				inviteePhone,
			});
			return response;
		} catch (error: any) {
			const message =
				error.response?.data?.message ||
				error.message ||
				"Failed to send circle invitation";
			return rejectWithValue(message);
		}
	},
);

export const fetchCircleInvitations = createAsyncThunk(
	"circleInvitation/fetchAll",
	async (_: void, { rejectWithValue }) => {
		try {
			const response = await submitFetchUserInvitations();
			return response;
		} catch (error: any) {
			const message =
				error.response?.data?.message ||
				error.message ||
				"Unknown Error Occurred";
			return rejectWithValue(message);
		}
	},
);

export const acceptCircleInvitation = createAsyncThunk(
	"circleInvitation/accept",
	async (
		{ invitationId, token }: { invitationId: string; token: string },
		{ rejectWithValue },
	) => {
		try {
			const response = await submitAcceptCircleInvitation(invitationId, token);
			return response;
		} catch (error: any) {
			const message =
				error.response?.data?.message ||
				error.message ||
				"Unknown Error Occurred";
			return rejectWithValue(message);
		}
	},
);

export const denyCircleInvitation = createAsyncThunk(
	"circleInvitation/deny",
	async (
		{ invitationId, token }: { invitationId: string; token?: string },
		{ rejectWithValue },
	) => {
		try {
			const response = await submitDenyCircleInvitation(invitationId, token);
			return response;
		} catch (error: any) {
			const message =
				error.response?.data?.message ||
				error.message ||
				"Unknown Error Occurred";
			return rejectWithValue(message);
		}
	},
);
